export enum BookingStatus {
  Active = "Active",
  Cancelled = "Cancelled"
}
